import React, { useState, useEffect } from "react";
import { Tabs, Tab, Box, Avatar } from "@mui/material";

const ServiceTabs = ({
  setSelectedService,
  setCategoryKey,
  selectedService,
  selectedCategory,
  categories,
  onCategoryChange, // New prop to notify parent about category change
}) => {
  const [activeTab, setActiveTab] = useState(0);

  // Update active tab when selectedService or categories change
  useEffect(() => {
    if (categories && categories.length > 0) {
      const selectedIndex = categories.findIndex(
        (category) => category.categoryName === selectedService
      );
      if (selectedIndex !== -1) {
        setActiveTab(selectedIndex);
      } else {
        // If selectedService is not found in categories, reset to the first tab
        setActiveTab(0);
        setSelectedService(categories[0].categoryName);
        setCategoryKey(categories[0].categoryKey);
      }
    }
  }, [selectedService, categories, setSelectedService, setCategoryKey]);

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);

    const selectedCategoryItem = categories[newValue];

    if (selectedCategoryItem) {
      // Update selected service and category key in the parent component
      setSelectedService(selectedCategoryItem.categoryName);
      setCategoryKey(selectedCategoryItem.categoryKey);

      // Notify parent component about the category change
      onCategoryChange(selectedCategoryItem);
    }
  };

  return (
    <Box
      sx={{
        borderRadius: "18px 18px 0px 0px",
        borderBottom: 1,
        borderColor: "divider",
        overflowX: "auto",
        backgroundColor: "#027BFE", // Blue background
        padding: "1rem",
      }}
    >
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        textColor="inherit"
        sx={{
          "& .MuiTabs-indicator": { backgroundColor: "white" }, // White indicator for selected tab
        }}
      >
        {categories.map((category, index) => (
          <Tab
            key={index}
            label={category.categoryName}
            icon={
              <Avatar
                src={category.iconUrl}
                alt={category.categoryName}
                sx={{ width: 32, height: 32, marginRight: 1 }} // Icon size
              />
            }
            value={index}
            sx={{
              color: "white", // Default text color (white for contrast)
              "&.Mui-selected": {
                color: "white", // Text color when selected (white for contrast)
                fontWeight: "bold", // Bold text for selected tab
              },
              "& .MuiTab-iconWrapper": {
                color: "white", // Icon color (white for contrast)
              },
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)", // Light white overlay on hover
              },
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default ServiceTabs;